module.exports = __webpack_public_path__ + "static/media/BAuth.b4aea99d.jpg";